module.exports = __webpack_public_path__ + "img/icon-tick.bd8df7fb.png";